import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function map(project) {
    return function (source) {
        return new Observable(function (subscriber) {
            var index = 0;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                subscriber.next(project(value, index++));
            }));
        });
    };
}
//# sourceMappingURL=map.js.map